import React from "react";
import { FiMapPin } from "react-icons/fi";

const greetingFor = (hour) => {
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

const GreetingTile = ({ employeeName, address, className = "" }) => {
  const now = new Date();
  const firstName = String(employeeName || "")
    .split("(")[0]
    .trim();

  return (
    <section
      className={`flex min-w-0 flex-col justify-center rounded-2xl border border-blue-100 bg-gradient-to-br from-purple-50 via-blue-50 to-white p-6 shadow-sm ${className}`}
    >
      <p className="text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-blue-700">
        {now.toLocaleDateString("en-US", {
          weekday: "long",
          day: "numeric",
          month: "long",
        })}
      </p>
      <h1 className="mt-2 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
        {greetingFor(now.getHours())},{" "}
        <span className="text-blue-700">{firstName}</span>
      </h1>
      {address ? (
        <p className="mt-3 flex items-start gap-1.5 text-sm text-gray-600">
          <FiMapPin className="mt-0.5 flex-none" size={14} />
          <span className="min-w-0">{address}</span>
        </p>
      ) : null}
    </section>
  );
};

export default GreetingTile;
